<ul>
<li *ngFor="let w of wiadomosci">
  <app-wiadomosc [wiadomosc]="w"></app-wiadomosc>
</li>
</ul>
